<template>
    <Page class="blog">
        <template v-if="post">
            <h1>{{post.title}}</h1>
            <div class="d-flex mb-8">
                <div class="pr-4">
                    <img height="48" :src="'/static/img/'+post.author.pic" :alt="post.author.name" class="avatar" />
                </div>
                <div>
                    <div>
                        {{post.author.name}}
                        <a v-if="post.author.linkedin" :href="'https://linkedin.com/in/'+post.author.linkedin" target="_blank" class="mr-1">
                            <v-icon size="20">mdi-linkedin</v-icon>
                        </a>
                        <a v-if="post.author.twitter" :href="'https://twitter.com/'+post.author.twitter" target="_blank" class="mr-1">
                            <v-icon size="20">mdi-twitter</v-icon>
                        </a>
                    </div>
                    <div class="grey--text">{{post.fDate}}</div>
                </div>
            </div>

            <v-container class="d-none d-sm-block pa-0 pt-16" style="position: absolute; height: 100%; pointer-events: none">
                <div style="position: sticky; top: 300px; display: flex; justify-content: end">
                    <div style="display: flex; flex-direction: column; pointer-events: all; margin-right: -36px; padding-right: 18px">
                        <a v-for="s in share" :href="s.url" target="_blank" rel="nofollow" :title="s.title" class="mr-0" @click="shareClick(s.name)">
                            <v-btn icon><v-icon>{{s.icon}}</v-icon></v-btn>
                        </a>
                    </div>
                </div>
            </v-container>

            <div class="pr-6">
                <component :is="post.text"></component>
            </div>

            <h2>Share this post</h2>
            <div>
                <a v-for="s in share" :href="s.url" target="_blank" rel="nofollow" :title="s.title" class="mr-0" @click="shareClick(s.name)">
                    <v-btn icon><v-icon>{{s.icon}}</v-icon></v-btn>
                </a>
            </div>
        </template>

        <template v-else>
            <div class="d-flex align-baseline">
                <h1>Blog</h1>
                <v-spacer />
                <a href="/blog/rss" target="_blank"><v-icon size="20" class="pb-1">mdi-rss</v-icon> RSS</a>
            </div>

            <table style="font-size: 20px">
                <tr v-for="p in posts">
                    <td class="py-3 pr-5 text-no-wrap">
                        <time :datetime="p.date"></time>
                        {{p.fDate}}
                    </td>
                    <td class="py-3">
                        <router-link :to="{name: 'blog', params: {name: p.name}}">{{p.title}}</router-link>
                    </td>
                </tr>
            </table>
        </template>
    </Page>
</template>

<script>
import Page from "@/pages/Page";
import IntroducingCoroot from "@/pages/posts/IntroducingCoroot";
import NodeAgentLogs from "@/pages/posts/NodeAgentLogs";
import ServiceMap from "@/pages/posts/ServiceMap";
import Ping from "@/pages/posts/Ping";
import EbpfPortability from "@/pages/posts/EbpfPortability";
import LinuxDelayAccounting from "@/pages/posts/LinuxDelayAccounting";
import CloudMetadata from "@/pages/posts/CloudMetadata";
import MissingPostgresMetrics from "@/pages/posts/MissingPostgresMetrics";
import HPA from "@/pages/posts/HPA";
import JustDefineYourSLOs from "@/pages/posts/JustDefineYourSLOs";
import PgAgent from "@/pages/posts/PgAgent";
import PgOperator from "@/pages/posts/PgOperator";
import AppCentricInspections from "@/pages/posts/AppCentricInspections";
import PostgresMonitoring from "@/pages/posts/PostgresMonitoring";
import ObservabilityTax from "@/pages/posts/ObservabilityTax";
import PillarsOfObservability from "@/pages/posts/PillarsOfObservability";
import ServiceToServiceCommunications from "@/pages/posts/ServiceToServiceCommunications";
import NetworkIssues from "@/pages/posts/NetworkIssues";
import RCA from "@/pages/posts/RCA.vue";
import PostgresIssues from "@/pages/posts/PostgresIssues.vue";
import Stackgres from "@/pages/posts/Stackgres.vue";
import OtelCosts from "@/pages/posts/OtelCosts.vue";
import MemoryIssues from "@/pages/posts/MemoryIssues.vue";
import ProfilesInClickhouse from "@/pages/posts/ProfilesInClickhouse.vue";
import PeterZaitsev from "@/pages/posts/PeterZaitsev.vue";
import BetterNetworkObservability from "@/pages/posts/BetterNetworkObservability.vue";
import OtelDemo from "@/pages/posts/OtelDemo.vue";
import NewTracing from "@/pages/posts/NewTracing.vue";
import CorootOnVM from "@/pages/posts/CorootOnVM.vue";
import SimplifyObservability from "@/pages/posts/SimplifyObservability.vue";
import DistributedTracingRED from "@/pages/posts/DistributedTracingRED.vue";
import DatadogNewOracle from "@/pages/posts/DatadogNewOracle.vue";
import DNSObservability from "@/pages/posts/DNSObservability.vue";
import WhatDevelopersShouldKnow from "@/pages/posts/WhatDevelopersShouldKnow.vue";
import GlobalConnectionTracking from "@/pages/posts/GlobalConnectionTracking.vue";
import PythonGIL from "@/pages/posts/PythonGIL.vue";

const authors = {
    nik: {
        name: 'Nikolay Sivko',
        pic: 'nik.png',
        linkedin: 'nikolay-sivko',
        twitter: 'NikolaySivko',
    },
    anton: {
        name: 'Anton Petruhin',
        pic: 'anton.png',
        linkedin: 'apetruhin',
        twitter: 'apetruhin',
    },
    pz: {
        name: 'Peter Zaitsev',
        pic: 'pz.png',
        linkedin: 'peterzaitsev',
        twitter: 'PeterZaitsev',
    },
}

const posts = {
    'introducing-coroot': {
        title: 'Introducing Coroot',
        text: IntroducingCoroot,
        date: '2022-02-01',
        author: authors.nik,
    },
    'mining-logs-from-unstructured-logs': {
        title: 'Mining metrics from unstructured logs',
        text: NodeAgentLogs,
        date: '2022-02-08',
        author: authors.nik,
    },
    'building-a-service-map-using-ebpf': {
        title: 'Building a service map using eBPF',
        text: ServiceMap,
        date: '2022-02-15',
        author: authors.nik,
    },
    'how-to-ping': {
        title: 'How ping measures network round-trip time accurately using SO_TIMESTAMPING',
        text: Ping,
        date: '2022-02-23',
        author: authors.nik,
    },
    'ebpf-portability': {
        title: 'The current state of eBPF portability',
        text: EbpfPortability,
        date: '2022-03-02',
        author: authors.anton,
    },
    'linux-delay-accounting': {
        title: 'Delay accounting: an underrated feature of the Linux kernel',
        text: LinuxDelayAccounting,
        date: '2022-03-09',
        author: authors.nik,
    },
    'cloud-metadata': {
        title: 'Gathering cloud instance metadata in AWS, GCP and Azure',
        text: CloudMetadata,
        date: '2022-03-16',
        author: authors.nik,
    },
    'pg-missing-metrics': {
        title: 'Missing metrics required to gain visibility into Postgres performance',
        text: MissingPostgresMetrics,
        date: '2022-04-12',
        author: authors.nik,
    },
    'kubernetes-hpa': {
        title: 'How quickly can the Kubernetes HPA scale your app?',
        text: HPA,
        date: '2022-04-19',
        author: authors.nik,
    },
    'just-define-your-slo-no-other-configuration-is-needed-to-automate-incident-investigation': {
        title: 'Just define your SLOs: no other configuration is needed to automate incident investigation',
        text: JustDefineYourSLOs,
        date: '2022-06-30',
        author: authors.nik,
    },
    'pg-agent': {
        title: 'Pg-agent – a Postgres exporter for Prometheus focusing on query performance statistics',
        text: PgAgent,
        date: '2022-07-14',
        author: authors.nik,
    },
    'chaos-testing-zalando-postgres-operator': {
        title: 'Chaos testing of a Postgres cluster managed by the Zalando Postgres Operator',
        text: PgOperator,
        date: '2022-08-11',
        author: authors.nik,
    },
    'app-centric-inspections': {
        title: 'App-centric inspections: turning the conventional metric analysis inside out',
        text: AppCentricInspections,
        date: '2022-10-14',
        author: authors.nik,
    },
    'advanced-postgres-monitoring': {
        title: 'Advanced Postgres monitoring with Coroot (Apache 2.0)',
        text: PostgresMonitoring,
        date: '2022-10-26',
        author: authors.nik,
    },
    'minimizing-observability-tax': {
        title: 'Using eBPF and predefined inspections to minimize "observability tax"',
        text: ObservabilityTax,
        date: '2022-12-23',
        author: authors.nik,
    },
    'pillars-of-observability': {
        title: 'The pillars of observability are just data, let\'s turn them into actionable insights',
        text: PillarsOfObservability,
        date: '2023-03-24',
        author: authors.nik,
    },
    'a-deep-dive-into-service-to-service-communications': {
        title: 'A deep dive into Service-to-Service communications in Kubernetes',
        text: ServiceToServiceCommunications,
        date: '2023-06-12',
        author: authors.nik,
    },
    'chaos-driven-observability-spotting-network-failures': {
        title: 'Chaos-driven observability: spotting network failures in a Kubernetes cluster',
        text: NetworkIssues,
        date: '2023-06-28',
        author: authors.nik,
    },
    'explaining-application-performance-anomalies-with-ai': {
        title: 'AI-powered root cause analysis based on precise telemetry data',
        text: RCA,
        date: '2023-07-25',
        author: authors.nik,
    },
    'spotting-postgres-performance-issues-with-coroot': {
        title: 'Spotting Postgres performance issues with Coroot',
        text: PostgresIssues,
        date: '2023-08-17',
        author: authors.nik,
    },
    'stackgres': {
        title: 'Chaos testing Kubernetes Operators for Postgres: StackGres',
        text: Stackgres,
        date: '2023-09-26',
        author: authors.nik,
    },
    'you-are-overpaying-for-opentelemetry-verbosity': {
        title: 'You\'re overpaying for OpenTelemetry\'s verbosity by at least 30%',
        text: OtelCosts,
        date: '2023-10-10',
        author: authors.nik,
    },
    'troubleshooting-memory-related-issues-in-kubernetes': {
        title: 'Troubleshooting memory-related issues in Kubernetes',
        text: MemoryIssues,
        date: '2023-11-13',
        author: authors.nik,
    },
    'storing-continuous-profiling-data-in-clickHouse': {
        title: 'Storing Continuous Profiling Data in ClickHouse',
        text: ProfilesInClickhouse,
        date: '2024-01-25',
        author: authors.nik,
    },
    'peter-zaitsev-is-joining-coroot': {
        title: 'Peter Zaitsev is joining Coroot as Co-founder',
        text: PeterZaitsev,
        date: '2024-01-29',
        author: authors.nik,
    },
    'better-network-observability-in-coroot': {
        title: 'Better Network observability in Coroot',
        text: BetterNetworkObservability,
        date: '2024-02-29',
        author: authors.pz,
    },
    'battletesting-coroot-with-otel-demo-and-chaos-mesh': {
        title: 'Battletesting Coroot with OpenTelemetry Demo and Chaos Mesh',
        text: OtelDemo,
        date: '2024-03-07',
        author: authors.nik,
    },
    'coroot-v1-0-revolutionizing-distributed-tracing-analysis': {
        title: 'Coroot v1.0: Revolutionizing Distributed Tracing Analysis',
        text: NewTracing,
        date: '2024-04-23',
        author: authors.nik,
    },
    'coroot-v1-0-unified-observability-for-heterogeneous-infrastructures': {
        title: 'Coroot v1.0: Unified Observability for Heterogeneous Infrastructures',
        text: CorootOnVM,
        date: '2024-04-23',
        author: authors.nik,
    },
    'it-is-the-time-to-simplify-observability': {
        title: 'It is the time to simplify Observability!',
        text: SimplifyObservability,
        date: '2024-04-23',
        author: authors.pz,
    },
    'implementing-red-method-with-distributed-tracing': {
        title: 'Implementing RED Method with Distributed Tracing',
        text: DistributedTracingRED,
        date: '2024-05-02',
        author: authors.pz,
    },
    'datadog-is-the-new-oracle': {
        title: 'Datadog is the new Oracle',
        text: DatadogNewOracle,
        date: '2024-05-20',
        author: authors.pz,
    },
    'why-should-you-care-about-dns-observability': {
        title: 'Why should you care about DNS Observability?',
        text: DNSObservability,
        date: '2024-06-07',
        author: authors.pz,
    },
    'what-developers-should-know-about-observability': {
        title: 'What Developers should know about Observability?',
        text: WhatDevelopersShouldKnow,
        date: '2024-07-05',
        author: authors.pz,
    },
    'discover-what-your-applications-are-really-up-to-with-coroot': {
        title: 'Discover what your applications are really up to with Coroot',
        text: GlobalConnectionTracking,
        date: '2024-07-12',
        author: authors.pz,
    },
    'instrumenting-python-gil-with-ebpf': {
        title: 'Instrumenting Python GIL with eBPF',
        text: PythonGIL,
        date: '2024-07-12',
        author: authors.nik,
    },
}

export default {
    components: {Page},
    props: {
        name: String,
    },

    computed: {
        posts(){
            const res = [];
            Object.keys(posts).forEach((name) => {
                const p = posts[name];
                res.push({...p, name, fDate: this.$format.date(p.date, '{MMM} {DD}, {YYYY}')})
            });
            return res.reverse();
        },
        post() {
            const p = this.posts.find((p) => p.name === this.name);
            document.title = (p ? p.title + ' | ' : '') + 'Blog | Coroot';
            return p;
        },
        share() {
            if (!this.post) {
                return null;
            }
            const url = 'https://coroot.com' + this.$route.fullPath;
            const title = encodeURIComponent(this.post.title);
            return [
                {name: 'twitter', title: 'Share on Twitter', icon: 'mdi-twitter', url: this.shareUrl('https://twitter.com/intent/tweet', {text: title, url, via: 'coroot_com', related: 'coroot_com'})},
                {name: 'facebook', title: 'Share on Facebook', icon: 'mdi-facebook', url: this.shareUrl('https://facebook.com/sharer.php', {u: url})},
                {name: 'reddit', title: 'Share on Reddit', icon: 'mdi-reddit', url: this.shareUrl('https://www.reddit.com/submit', {title, url})},
                {name: 'hackernews', title: 'Share on Hacker News', icon: 'mdi-alpha-y-box', url: this.shareUrl('https://news.ycombinator.com/submitlink', {t: title, u: url})},
                {name: 'linkedin', title: 'Share on LinkedIn', icon: 'mdi-linkedin', url: this.shareUrl('https://www.linkedin.com/shareArticle', {title, url, mini: 'true'})},
            ];
        }
    },

    methods: {
        shareClick(to) {
            this.$st.send('share', {to});
        },
        shareUrl(url, params) {
            const ps = Object.entries(params).map((e) => {
                return e[0] + '=' + e[1];
            })
            return url + '?' + ps.join('&');
        }
    },
}
</script>

<style scoped>
.blog {
    font-family: Poppins, sans-serif;
}
.post {
    padding: 30px 0;
}
.post:not(:last-child) {
    border-bottom: black solid 2px;
}
.post a {
    font-size: 24px;
    font-weight: 600;
    color: black;
}
.post a:hover {
    color: #3ba837;
}
.avatar {
    border-radius: 100%;
}

</style>
